/**
 * Message
 * The Message API
 *
 * The version of the OpenAPI document: master-8247d258-900790
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Reference } from './reference';


export interface ChatDto { 
    id: string;
    type: ChatDtoType;
    organization: Reference;
    peopleOrganization?: Reference;
    title?: string;
    createdAt: string;
    updatedAt: string;
    pinnedAt?: string;
    readAt?: string;
    latestMessageAt?: string;
    /**
     * Reference to admin
     */
    createdBy: Reference;
}
export enum ChatDtoType {
    Private = 'private',
    Group = 'group'
};



